import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import CreateAppModal from "../generate/CreateApp";

const AiBuilder = () => {
  const navigate = useNavigate();
  return <CreateAppModal type="ai" hide={() => navigate("/apps")} />;
};
export default AiBuilder;

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--grey1);
  background: radial-gradient(
    circle,
    rgba(195, 226, 247, 0.15) 0%,
    rgba(193, 242, 205, 0.15) 20%,
    rgba(238, 205, 250, 0.15) 40%,
    rgba(250, 208, 223, 0.15) 60%,
    rgba(192, 240, 240, 0.15) 80%,
    rgba(255, 197, 178, 0.15) 100%
  );
  background-size: 500% 500%;
  animation: ${gradientAnimation} 30s ease infinite;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
